import { AnyAction } from '@reduxjs/toolkit';
import { FetchWelldesignUsersRoutine } from '../redux-routines';
import { TWelldesignUsersListState } from '../interfaces';

const initialState: TWelldesignUsersListState = {
  isFetching: false,
  data: [],
  error: null,
};

export const welldesignUsersListReducer = (
  state: TWelldesignUsersListState = initialState,
  action: AnyAction,
): TWelldesignUsersListState => {
  switch (action.type) {
    case FetchWelldesignUsersRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
        error: null,
      };
    case FetchWelldesignUsersRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case FetchWelldesignUsersRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
